import axios from 'axios';

const chatbotUrl = process.env.VUE_APP_JA_CHATBOT_URL;
const chatbotApiKey = process.env.VUE_APP_JA_CHATBOT_API_KEY;

const config = {
	headers: {
		'X-API-KEY': chatbotApiKey,
		'Content-Type': 'application/json'
	}
};

function getHistory(studentId) {
	return axios.get(`${chatbotUrl}/history/${studentId}`, config);
}

function sendAnswer(data) {
	return axios.post(`${chatbotUrl}/answer/`, data, config);
}

export default {
	getHistory,
	sendAnswer
};
